var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.9998 29.3327C23.3636 29.3327 29.3332 23.3631 29.3332 15.9993C29.3332 8.63555 23.3636 2.66602 15.9998 2.66602C8.63604 2.66602 2.6665 8.63555 2.6665 15.9993C2.6665 23.3631 8.63604 29.3327 15.9998 29.3327Z",
    fill: "#92ABFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4133 16.0005L20.48 12.9338C20.8666 12.5471 20.8666 11.9071 20.48 11.5205C20.0933 11.1338 19.4533 11.1338 19.0666 11.5205L16 14.5871L12.9333 11.5205C12.5466 11.1338 11.9066 11.1338 11.52 11.5205C11.1333 11.9071 11.1333 12.5471 11.52 12.9338L14.5866 16.0005L11.52 19.0671C11.1333 19.4538 11.1333 20.0938 11.52 20.4805C11.72 20.6805 11.9733 20.7738 12.2266 20.7738C12.48 20.7738 12.7333 20.6805 12.9333 20.4805L16 17.4138L19.0666 20.4805C19.2666 20.6805 19.52 20.7738 19.7733 20.7738C20.0266 20.7738 20.28 20.6805 20.48 20.4805C20.8666 20.0938 20.8666 19.4538 20.48 19.0671L17.4133 16.0005Z",
    fill: "#92ABFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/close-circle.be2189058435f03bdbfefb4cdeb93654.svg";
export { ForwardRef as ReactComponent };